import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const HomePage = () => {
  return (
    <div data-testid="homepage">
      {/* Hero Section */}
      <section
        className="relative min-h-[100dvh] flex items-center justify-center overflow-hidden pt-28 pb-8"
        data-testid="hero-section"
      >
        {/* Plain Black with Subtle Noise Texture */}
        <div className="absolute inset-0 bg-black hero-texture" />

        {/* Content */}
        <div className="relative z-10 max-w-[1200px] mx-auto px-6 text-center">
          {/* Main Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl sm:text-5xl md:text-6xl font-semibold text-[#F5F5F7] tracking-tight leading-[1.1] mb-8"
            data-testid="hero-title"
          >
            Build, scale, and<br />
            <span className="gradient-text">modernize</span> with Appface.
          </motion.h1>

          {/* Subtitle - Compact Description */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-base md:text-lg text-[#86868B] max-w-4xl mx-auto mb-12 leading-relaxed text-left"
            data-testid="hero-subtitle"
          >
            <p className="mb-4">
              <strong className="text-[#F5F5F7]">Appface Technologies Pvt. Ltd.</strong> is a Bangalore-based technology company specializing in building powerful digital products for businesses across industries. Founded in 2011, Appface focuses on delivering high-quality software solutions that help organizations transform their ideas into scalable, real-world applications.
            </p>
            <p className="mb-4">
              Our core expertise lies in <strong className="text-[#F5F5F7]">mobile app development</strong>, <strong className="text-[#F5F5F7]">web platforms</strong>, <strong className="text-[#F5F5F7]">cloud-based systems</strong>, and <strong className="text-[#F5F5F7]">custom enterprise software</strong>. We work with startups, growing companies, and established enterprises to design and develop technology that is reliable, intuitive, and built for long-term growth. From concept and strategy to development, deployment, and ongoing support, our team partners closely with clients at every stage of the product lifecycle.
            </p>
            <p>
              At Appface, we believe great technology should solve real problems. Our development approach combines user-centered design, modern engineering practices, and scalable architecture to create products that perform seamlessly and deliver meaningful value. Whether it's a mobile application, a complex backend system, or an integrated digital platform, we focus on building solutions that are secure, efficient, and future-ready.
            </p>
          </motion.div>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4"
            data-testid="hero-cta"
          >
            <Link
              to="/contact"
              className="btn-primary px-8 py-4 rounded-full text-base font-medium flex items-center gap-2"
              data-testid="hero-cta-primary"
            >
              Get in Touch
              <ArrowRight size={18} />
            </Link>
            <Link
              to="/services"
              className="btn-secondary px-8 py-4 rounded-full text-base font-medium"
              data-testid="hero-cta-secondary"
            >
              View Services
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
